import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "./Input";
import Radio from "./Radio";
import Options from "./Options";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { pekerjaan, pendidikan, penghasilan, status } from "./OptSelect";
import { findAyah } from "../store/actions/santri";
import { santriActions } from "../store/slice/santri";

const FormAyah = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const { santriOne, loadingSantri, ayahOne } = useSelector(
    (state) => state.santri
  );
  const location = useLocation();
  const methodAyah = useForm({
    mode: "all",
    resolver: yupResolver(
      yup.object().shape({
        nama: yup.string().required("Tidak Boleh Kosong"),
        t_lahir: yup.string().required("Tidak Boleh Kosong"),
        tgl_lahir: yup.string().required("Tidak Boleh Kosong"),
        thn_lahir: yup.string().required("Tidak Boleh Kosong"),
        nik: yup
          .string()
          .min(16, "Tidak Boleh Kurang dari 16 karakter")
          .max(16, "Tidak Boleh Lebih dari 16 karakter")
          .required("Tidak Boleh Kosong"),
        kewarganegaraan: yup
          .string()
          .oneOf(["WNI", "WNA"], "Pilih Salah Satu")
          .required("Tidak Boleh Kosong"),
        alamat: yup.string().required("Tidak Boleh Kosong"),
        pendidikan: yup.string().required("Tidak Boleh Kosong"),
        pekerjaan: yup.string().required("Tidak Boleh Kosong"),
        penghasilan: yup.string().required("Tidak Boleh Kosong"),
        status: yup.string().required("Tidak Boleh Kosong"),
        no_wa: yup.string().required("Tidak Boleh Kosong"),
        no_hp: yup.string().required("Tidak Boleh Kosong"),
      })
    ),
  });
  const watchNik = methodAyah.watch("nik");
  useImperativeHandle(ref, () => ({
    method: methodAyah,
  }));
  useEffect(() => {
    if (ayahOne?.nik) {
      methodAyah.reset({ ...ayahOne });
    }
  }, [ayahOne?.nik]);
  useEffect(() => {
    if (location.pathname !== "/home/input/santri") {
      if (santriOne?.ayah) {
        methodAyah.reset({ ...santriOne?.ayah });
      } else {
        methodAyah.reset({
          nama: "",
          t_lahir: "",
          tgl_lahir: "",
          thn_lahir: "",
          nik: "",
          kewarganegaraan: "",
          pendidikan: "",
          pekerjaan: "",
          penghasilan: "",
          alamat: "",
          status: "",
          no_hp: "",
          no_wa: "",
        });
      }
    }
  }, [santriOne?.ayah]);
  useEffect(() => {
    dispatch(santriActions.clearAyah());
    if (watchNik?.length === 16) {
      dispatch(findAyah({ nik: watchNik, statusOrtu: "ayah" }));
    }
  }, [watchNik, santriOne?.ayah]);
  return (
    <div>
      <form className="md:grid md:grid-cols-2 md:gap-5">
        <Input label="NIK" method={methodAyah} methodName="nik" type="number" />
        <Input label="Nama Lengkap" method={methodAyah} methodName="nama" />
        <Input label="Tempat Lahir" method={methodAyah} methodName="t_lahir" />
        <Input
          label="Tanggal Lahir"
          method={methodAyah}
          methodName="tgl_lahir"
          type="date"
        />
        <Input
          label="Tahun Lahir"
          method={methodAyah}
          methodName="thn_lahir"
          type="number"
        />
        <div>
          <h1 className="font-light text-lg mb-2">kewarganegaraan</h1>
          <div className="flex my-auto md:space-x-0 space-x-2">
            <Radio
              method={methodAyah}
              methodName="kewarganegaraan"
              value="WNI"
              label="WNI"
            />
            <Radio
              method={methodAyah}
              methodName="kewarganegaraan"
              value="WNA"
              label="WNA"
            />
          </div>
          {methodAyah.formState.errors["kewarganegaraan"] && (
            <p className="text-red-600 mt-1 mx-1">
              {methodAyah.formState.errors["kewarganegaraan"].message}
            </p>
          )}
        </div>
        <Input label="Alamat" method={methodAyah} methodName="alamat" />
        <Options
          label="Pendidikan"
          method={methodAyah}
          methodName="pendidikan"
          options={pendidikan}
        />
        <Options
          label="Pekerjaan"
          method={methodAyah}
          methodName="pekerjaan"
          options={pekerjaan}
        />
        <Options
          label="Penghasilan"
          method={methodAyah}
          methodName="penghasilan"
          options={penghasilan}
        />
        <Options
          label="Status"
          method={methodAyah}
          methodName="status"
          options={status}
        />
        <Input label="Nomor WA" method={methodAyah} methodName="no_wa" />
        <Input label="Nomor HP" method={methodAyah} methodName="no_hp" />
      </form>
    </div>
  );
});

export default FormAyah;
